<template>
  <main class="cd-main-content wp_AllPageMarginTop"
								style="min-height: 90vh">
    <!--<loading :active.sync="showLoader"-->
    <!--:can-cancel="false"-->
    <!--:is-full-page="false"-->
    <!--:opacity="1"-->
    <!--&gt;-->
    <!--</loading>-->
			<page-loader v-if="showProductListingLoader || getshowSortFilterLoader">
			</page-loader>
			<div v-show="!(showProductListingLoader || getshowSortFilterLoader)">
    <svg
      xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      style="position: absolute; width: 0; height: 0; overflow: hidden;"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
						id="productListingPageSvg"
    >
      <defs>
        <symbol id="icon-cart" viewBox="0 0 32 32">
          <!--<title>cart</title>-->
          <path
            d="M12 29c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657
          1.343-3 3-3s3 1.343 3 3z"
          />
          <path
            d="M32 29c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657
          1.343-3 3-3s3 1.343 3 3z"
          />
          <path
            d="M32 16v-12h-24c0-1.105-0.895-2-2-2h-6v2h4l1.502
            12.877c-0.915 0.733-1.502 1.859-1.502 3.123 0 2.209
            1.791 4 4 4h24v-2h-24c-1.105 0-2-0.895-2-2 0-0.007 0-0.014
            0-0.020l26-3.98z"
          />
        </symbol>
        <symbol id="icon-heart" viewBox="0 0 32 32">
          <title>heart</title>
          <path
            d="M23.6 2c-3.363 0-6.258 2.736-7.599
          5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637
          0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001
          21.232 6.13-9.268 15.999-12.1 15.999-21.232
          0-4.637-3.763-8.401-8.4-8.401z"
          />
        </symbol>
        <symbol id="icon-heart-broken" viewBox="0 0 32 32">
          <title>heart-broken</title>
          <path
            d="M23.6 2c4.637 0 8.4 3.764 8.4 8.401 0 9.132-9.87
          11.964-15.999 21.232-6.485-9.326-16.001-11.799-16.001-21.232
          0-4.637 3.763-8.401 8.4-8.401 1.886 0 3.625 0.86 5.025
          2.12l-2.425 3.88 7 4-4 10 11-12-7-4 1.934-2.901c1.107-0.68
          2.35-1.099 3.665-1.099z"
          />
        </symbol>
      </defs>
    </svg>
    <!-- new filter -->
			<mobile-filter @onLoading="onLoading"/>
    <!-- new filter -->

    <div class="container wp_ContentsContainer wp_productListMarginTop pb-4">
      <div class>
        <div class="container-fluid">
          <div class="row ml-0">
											<filter-side-panel
												v-if="!($route.path === '/promotional_product-list') &&
                               (getSelectedProduct.length > 0 || getFilterAppliedStatus)"
												:showLoader="showProductListingLoader"
												@onLoading="onLoading"
											/>
											<sort-tab :sortOptions="sortOptions"/>
											<product-list-section
												:productList="getSelectedProduct"
												:showLoader="showProductListingLoader"
												:activeCategory="activeCategory"
												:hideSort="hideSort"
											/>
          </div>
        </div>
      </div>
    </div>
			</div>
  </main>
</template>

<script>
// import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';
import { mapActions, mapGetters } from 'vuex'
import { productApi } from '@/services/ApiServices/productApi'
import { store } from '@/store/store'
import { brandApis } from '../../../services/ApiServices/brandApis'
import MobileFilter from './filters/MobileFilter'
import FilterSidePanel from './filters/filterSidePanel/FilterSidePanel'
import SortTab from './sort/SortTab'
import ProductListSection from './section/ProductListSection'
import PageLoader from '../../shared/loader/pageLoader'

export default {
	components: {
		PageLoader,
		ProductListSection,
		SortTab,
		FilterSidePanel,
		MobileFilter
		// FilterTopBanner,
		// Loading
	},
	data () {
		return {
			showProductListingLoader: false,
			activeCategory: '',
			isLoading: false,
			hideSort: true,
			sortOptions: [
				{
					name: 'Name A->Z',
					sortOrder: 'ASC',
					sortMethod: 'NAME'
				},
				{
					name: 'Name Z->A',
					sortOrder: 'DES',
					sortMethod: 'NAME'
				},
				{
					name: 'Vendor A->Z',
					sortOrder: 'ASC',
					sortMethod: 'VENDOR'
				},
				{
					name: 'Vendor Z->A',
					sortOrder: 'DES',
					sortMethod: 'VENDOR'
				},
				{
					name: 'Popularity',
					sortOrder: 'DES',
					sortMethod: 'SALES'
				},
				{
					name: 'Price Low to High',
					sortOrder: 'ASC',
					sortMethod: 'PRICE'
				},
				{
					name: 'Price High to Low',
					sortOrder: 'DES',
					sortMethod: 'PRICE'
				}
			]
		}
	},
	computed: {
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('home', ['getrecommendedProduct']),
		...mapGetters('category', ['getCategoryData']),
		...mapGetters('filters', [
			'getFilters',
			'isFilterApplied',
			'getFilterAppliedStatus',
			'getshowSortFilterLoader'
		])
	},
	beforeMount () {
		this.filterToggler()
		store.dispatch('buynow/deleteFromBuyNow')
		store.dispatch('filters/setSortFilterLoader', false)
		this.bindProducts()
	},
	beforeRouteEnter (to, from, next) {
		if (to.path === '/product-list') {
			document.title = to.query.name
			document.description = 'product has unique features'
		} else if (to.path === '/search-results') {
			document.title = to.query.search_name
		} else if (to.path === '/promotional_product-list') {
			document.title = to.query.promotionId
		} else {
			document.title = 'Products'
		}
		next()
	},
	watch: {
		$route () {
			if (this.$route.path === '/product-list') {
				document.title = this.$route.query.name
				document.description = 'product has unique features'
			} else if (this.$route.path === '/search-results') {
				document.title = this.$route.query.search_name
			} else if (this.$route.path === '/promotional_product-list') {
				document.title = this.$route.query.promotionId
			} else {
				document.title = 'Products'
			}
			this.bindProducts()
		}
	},
	methods: {
		...mapActions('filters', [
			'emptyFilters',
			'updatePriceRange',
			'updateFilterApplied',
			'setFilter',
			'updateKeyWord',
			'resetFilters',
			'updateFilters'
		]),
		...mapActions('category', ['setActiveCategories']),
		...mapActions('productselected', [
			'setSelectedProductData',
			'clearSelectedProductData'
		]),
		onLoading (loadingValue) {
			this.showProductListingLoader = loadingValue
		},
		filterToggler () {
			$(document).ready(() => {
				$('.slidingDiv').hide()
				$('.show_hide').show()

				$('.show_hide').click(() => {
					$('.slidingDiv').toggle('slide')
				})
			})
		},
		promotionFunction (promotion) {
			this.clearSelectedProductData()
			productApi.getPromotionalProducts(promotion).then((res) => {
				this.showProductListingLoader = false
				this.$forceUpdate()
			})
		},
		getCategory (categoryData) {
			this.clearSelectedProductData()
			const keyWord = {
				name: categoryData.name,
				category_id: categoryData.category,
				is_a_category: true
			}
			productApi
				.getSearchedFilteredProducts(
					{ query_parameter: keyWord },
					'searchProducts'
				)
				.then(res => {
					if (res) {
						this.showProductListingLoader = false
						this.$forceUpdate()
					}
				})
				.catch(e => {
					this.emptyFilters()
					this.setActiveCategories([])
					// this.updateFilterApplied(false);
					this.setSelectedProductData([])
				})
		},
		bindProducts () {
			this.showProductListingLoader = true
			if (this.$route.query.promotionId) {
				if (this.$route.query.category) {
					this.activeCategory = this.$route.query.category
					this.getCategory(this.$route.query)
				} else {
					this.promotionFunction(this.$route.query.promotionId)
				}
			} else if (this.$route.query.category) {
				this.activeCategory = this.$route.query.category
				this.getCategory(this.$route.query)
			} else if (this.$route.query.product_length) {
				productApi
					.getSearchedFilteredProducts(
						{ filter_class: { filters: [], brands: [], ratings: [] } },
						'filteredAllProducts'
					)
					.then(res => {
						if (res) {
							this.showProductListingLoader = false
							this.$nextTick(() => {
								this.$forceUpdate()
							})
						}
					})
			} else if (this.$route.query.search_name) {
				// this.showProductListingLoader = true
				productApi
					.getSearchedFilteredProducts(
						{ query_parameter: this.$route.query },
						'searchProducts'
					)
					.then(() => {
						this.showProductListingLoader = false
					})
			} else if (this.$route.query.brand_id) {
				// this.showProductListingLoader = true
				brandApis
					.brandData(
						this.$route.query.brand_id,
						this.$route.query.current_category_id
					)
					.then(() => {
						this.showProductListingLoader = false
						this.hideSort = false
					})
			} else if (this.$route.query.recommendProductCount) {
				store.dispatch('productselected/clearSelectedProductData')
				productApi.getRecommendedProducts(this.$route.query.recommendProductCount)
					.then((res) => {
						store.dispatch('productselected/setSelectedProductData', this.getrecommendedProduct)
						this.showLoader = false
						this.hideSort = false
					})
			}
		}
	}
}
</script>
